<header
    (click)="toggleExpansion()"
    class="head ps-2 pt-4 pe-2"
    [ngClass]="isExpanded ? 'pb-6' : 'pb-4'"
>
    <app-icon type="PlusCircle" *ngIf="!isExpanded"></app-icon>
    <app-icon type="MinusCircle" *ngIf="isExpanded"></app-icon>
    <h4 class="title ms-4">{{ accordionTitle }}</h4>
</header>
<section [ngClass]="isExpanded ? 'd-block' : 'd-none'" class="pb-4 me-2">
    <ng-content></ng-content>
    <button class="show-more-button mt-2" (click)="toggleShowMore()" *ngIf="isShowAllButtonVisible">
        {{ allItemsVisible ? "- See Less" : "+ See All" }}
    </button>
</section>
